// Separate axios instance for the Vendor Portal. Uses its own token in
// localStorage so vendor sessions don't collide with Trust/Institute admin
// sessions, and 401s here redirect to /vendor/login (not admin login).

import axios from "axios";
import { API } from "@/lib/api";

export const VENDOR_TOKEN_KEY = "gsm_vendor_token";

const vendorApi = axios.create({ baseURL: API });

vendorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(VENDOR_TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

vendorApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      localStorage.removeItem(VENDOR_TOKEN_KEY);
      if (path.startsWith("/vendor") && path !== "/vendor/login") {
        window.location.assign("/vendor/login");
      }
    }
    return Promise.reject(err);
  }
);

export default vendorApi;
